var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.7,2.7H3.3C3,2.7,2.7,3,2.7,3.3v9.3c0,0.4,0.3,0.7,0.7,0.7h9.3c0.4,0,0.7-0.3,0.7-0.7V3.3 C13.3,3,13,2.7,12.7,2.7z M3.3,1.3c-1.1,0-2,0.9-2,2v9.3c0,1.1,0.9,2,2,2h9.3c1.1,0,2-0.9,2-2V3.3c0-1.1-0.9-2-2-2H3.3z M4,4.7h2.7 V6H4V4.7z M6.7,7.3H4v1.3h2.7V7.3z M8,4.7h4v6.7H8V4.7z M6.7,10H4v1.3h2.7V10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaPanel);
export default __webpack_public_path__ + "static/media/Meta-Panel.de3d8ae67ac042328c7b511ae03a0921.svg";
export { ForwardRef as ReactComponent };